<div class="row">
  <div class="col-lg-12">
    <div class="card mb-0">
      <div class="card-body">
        <form [formGroup]="tripForm" (ngSubmit)="submitForm()">
          <div class="d-flex flex-wrap align-items-end gap-2">
            @if (!lockMode && showModeToggle) {
              <div class="btn-group trip-ready-mode-toggle" role="group">
                <button type="button" class="btn btn-outline-primary" [class.active]="displayMode==='landing'" (click)="selectMode('landing')">Landing Page</button>
                <button type="button" class="btn btn-outline-primary" [class.active]="displayMode==='json'"    (click)="selectMode('json')">Structured</button>
              </div>
            }

            @if (countriesLoadFailed) {
              <div class="alert alert-warning w-100 mb-2 py-2 px-3">
                The country list is unavailable, so Origin and Destination cannot be selected. Please try again shortly, and if the problem persists contact support.
              </div>
            }

            <div class="flex-grow-1" style="min-width: 180px;">
              <label class="form-label mb-1">Origin <span class="text-danger">*</span></label>
              <ng-select formControlName="origin"
                         [items]="countries"
                         bindLabel="name"
                         bindValue="iso_code"
                         placeholder="Select origin..."
                         appendTo="body"
                         [searchable]="true"
                         [clearable]="true"
                         [class.is-invalid]="formSubmitted && form['origin'].errors">
              </ng-select>
            </div>

            <div class="flex-grow-1" style="min-width: 180px;">
              <label class="form-label mb-1">Destination <span class="text-danger">*</span></label>
              <ng-select formControlName="destination"
                         [items]="countries"
                         bindLabel="name"
                         bindValue="iso_code"
                         placeholder="Select destination..."
                         appendTo="body"
                         [searchable]="true"
                         [clearable]="true"
                         [class.is-invalid]="formSubmitted && form['destination'].errors">
              </ng-select>
            </div>

            <div style="min-width: 150px;">
              <label class="form-label mb-1">From <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="fromDate"
                     [class.is-invalid]="formSubmitted && form['fromDate'].errors" />
            </div>

            <div style="min-width: 150px;">
              <label class="form-label mb-1">To <span class="text-danger">*</span></label>
              <input type="date" class="form-control" formControlName="toDate"
                     [class.is-invalid]="formSubmitted && form['toDate'].errors" />
            </div>

            <button type="button" class="btn btn-light" (click)="clearResult()">Clear</button>
            <button type="submit" class="btn btn-info" [disabled]="isLoading">
              @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
              Generate
            </button>
          </div>

          @if (validationError) {
            <div class="alert alert-warning mt-3 mb-0">{{ validationError }}</div>
          }
        </form>
      </div>
    </div>
  </div>
</div>

@if (landingUrl && displayMode==='landing') {
  <div class="row">
    <div class="col-lg-12">
      <div class="card mb-0">
        <div class="card-body p-0">
          <iframe [src]="landingUrl" style="width:100%; height:80vh; border:none;" title="TripReady"></iframe>
        </div>
      </div>
    </div>
  </div>
}

@if (result && displayMode==='json') {
  <div class="row mt-3">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header"><h5 class="card-title mb-0">TripReady Result</h5></div>
        <div class="card-body">
          <p class="text-muted">JSON:API result with {{ result.data?.length || 0 }} primary resources and {{ result.included?.length || 0 }} included resources.</p>
          <details>
            <summary class="text-info" style="cursor:pointer;">View raw JSON</summary>
            <pre class="bg-light p-3 mt-2 rounded">{{ result | json }}</pre>
          </details>
        </div>
      </div>
    </div>
  </div>
}
